import { CloseOutlined } from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { useSelector } from 'react-redux';
import { QueryKeys } from '../../constants/query_keys';
import { useBannerPreferences } from '../../hooks/use_banner_preferences';
import { apiV1 } from '../../lib/api';
import { BannerKeys } from '../../redux/banner_preferences';
import { getExperimentUuid } from '../../redux/user';
import { OmniaLinkButton } from '../omnia_button/omnia_link_button';
import appIcon from './app_icon.webp';

interface BannerWaterbodyBoatRampsProps {
  urlSlug: string;
}

export const BannerWaterbodyBoatRamps = (props: BannerWaterbodyBoatRampsProps) => {
  const { urlSlug } = props;
  const { isBannerHidden, setBannerPreferencesHidden } = useBannerPreferences();
  const bannerKey = BannerKeys.WATERBODY_BOAT_RAMPS;
  const hidden = isBannerHidden(bannerKey);
  const experimentUuid = useSelector(getExperimentUuid);
  const appUrl = `https://go.omniafishing.com/gZRj/onpmlmik?anonymous_id=${experimentUuid}`;

  const waterbodyQuery = useQuery({
    queryKey: QueryKeys.WATERBODIES.BY_SLUG_OR_ID(urlSlug),
    queryFn: async () => {
      const res = await apiV1.waterbodyFetch(urlSlug);
      return res.data.data;
    },
    enabled: !hidden && !!urlSlug,
  });

  const { data: waterbody } = waterbodyQuery;

  if (hidden || !waterbody) {
    return null;
  }

  return (
    <div className="fixed bg-[#002b3a] text-white bottom-0 left-0 right-0 p-3 pl-0 flex items-center justify-between z-[1000] gap-3 shadow shadow-black/20">
      <div
        className="p-3 -mr-3 opacity-50 flex-grow-0 flex-shrink-0"
        onClick={() => setBannerPreferencesHidden(bannerKey)}
        role="button"
        aria-label="Close banner"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            setBannerPreferencesHidden(bannerKey);
          }
        }}
      >
        <CloseOutlined />
      </div>
      <div className="w-10 flex-grow-0 flex-shrink-0 rounded-xl overflow-hidden">
        <a href={appUrl}>
          <img src={appIcon} alt="Omnia Fishing App Icon" />
        </a>
      </div>
      <div>
        <p className="uppercase font-bold leading-tight">{waterbody.primary_name} In Your Pocket</p>
        <p className="text-xs">Even better boat landings with live wind + Navionics® in our app</p>
      </div>
      <div className="flex-grow-0 flex-shrink-0">
        <OmniaLinkButton size="md" kind="primary" to={appUrl}>
          GET
        </OmniaLinkButton>
      </div>
    </div>
  );
};
